import React, { useEffect, useId, useRef, useState } from "react";
import Footer from "./footer";
import ModalDialog from "@atlaskit/modal-dialog";
import Toggle from "@atlaskit/toggle";
import Config from "../config";
import { isEmpty } from "lodash";
import { makeStyles } from "@material-ui/styles";

import { messages, stripeMessage } from "../welcome-dashboard/messages";
import Toast from "react-simple-toasts";
import {
  apiVersion,
  getLJsonStorage,
  usePrevious,
} from "../welcome-dashboard/Utils";
import { connectAccountFlag, getBaseConfig, handlePaymentWindow, preventMinus } from "../Utils";
import {
  hideApiLoader,
  setUserLoginData,
  showApiLoader,
} from "../redux/tool-webjam/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  claimRoomRequest,
  createConnectLink,
  getRoomInfo,
  getUserLocation,
  updateRoomDetail,
} from "../welcome-dashboard/Request.d";
import toast from "react-simple-toasts";
import config from "../config";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const { socket_endpoint } = Config;
var url = window.location.href.replace(/\/$/, "");
var lastSeg = url.substr(url.lastIndexOf("/") + 1);
import { v4 as uuidv4 } from "uuid";
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from "../constant";
import PaymentAccountModal from "./PaymentAccountModal";
import { setStripeRequesting } from "../redux/tool-webjam-v2/actions";
import Button from "@atlaskit/button/standard-button";
import { CURRENT_ROOM_NAME, Constant } from "../../webjam/constant";
import { socketEmit } from "../../../../socket";
import { copyText } from "../../base/util/copyText.web";
import { Tooltip } from "@mui/material";
import { toggleLobbyMode } from "../../lobby/actions.any";
import Dialog from "../../base/ui/components/web/Dialog";
import { checkSubscription, ct, dynamicMessageLocale, localeCalender } from "../constant-Utils";
import { handleSubscription } from "../custom/components/CommonComponents";

let getLocalAuth = "";
if (localStorage.getItem("auth")) {
  getLocalAuth = JSON.parse(localStorage.getItem("auth"));
}

const useStyles = makeStyles((theme) => {
  return {
    inputError: {
      color: "#ff7373 !important",
      background: "transparent !important"
    },
  };
});

const ClaimRoomModel = (props) => {
  const classes = useStyles();
  const { changePopupState, userEmail, userLoginData, roomType } = props;

  let isStripeConnect = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX_V2].isStripeConnect
  );
  let isStripeConnectVerified = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX_V2].isStripeConnectVerified
  );
  let isStripeRequesting = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX_V2].isStripeRequesting
  );
  let authOrganization = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX_V2].authOrganization
  );

  let clickedAutoMakeHost = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX].clickedAutoMakeHost
  );



  const dispatch = useDispatch();
  const [isloading, setLoading] = useState(false);
  const [connectAccount, setConnectAccount] = useState(false);
  const [connectAccountVerified, setConnectAccountVerified] = useState("");
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [connectApprovedFlash, setConnectApprovedFlash] = useState(false);

  var _roomName = CURRENT_ROOM_NAME;
  // if (_roomName) {
  //   _roomName = _roomName.substring(1);
  // }

  const [roomDetail, setRoomDetail] = useState({
    room: {
      paid: false,
      groupName: _roomName,
      password: "",
      private: false,
      publish: false,
      userName: "",
      id: "",
      category: "",
      room_amount: "",
      endDate: "",
    },
  });

  const [errors, setErrors] = useState({
    category: "",
    payment: "",
    roomDate: "",
  });

  const [isSubmitLoading, setSubmitLoading] = useState(true);
  const [connectPop, setConnectPop] = useState(false);

  const paidRef = useRef();
  const eDateRef = useRef();

  useEffect(() => {
    if (userLoginData.room) {
      let { paid, groupName, password, publish, userName, id, category } =
        userLoginData?.room;

      setRoomDetail({
        ...roomDetail,
        room: {
          paid,
          groupName,
          password,
          private: userLoginData.room.private,
          publish,
          userName,
          id,
          category,
          room_amount: paid ? userLoginData?.paidDetail?.amount : "",
          endDate:
            paid && userLoginData.room?.endDate
              ? new Date(userLoginData.room?.endDate)
              : "",
        },
      });
    }

    let hasConnect = getLJsonStorage("auth", "stripe_account_id");
    let hasVerified = getLJsonStorage("auth", "connectVerified");

    // if (hasConnect) {
    //   setConnectAccount(true)
    // }

    // setConnectAccountVerified(hasVerified)

    if (userLoginData?.user?.stripe_account_id) {
      setConnectAccount(true);
      if (userLoginData?.user?.connectVerified != "") {
        setConnectAccountVerified(userLoginData?.user?.connectVerified);
      }
    }

    return () => {
      setConnectApprovedFlash(false);
      setConnectAccountVerified("");
    };
  }, []);

  useEffect(() => {
    if (isStripeConnect) {
      setConnectAccount(true);
    }
  }, [isStripeConnect]);

  let prevStripeStatus = usePrevious(isStripeConnectVerified);

  useEffect(() => {
    if (isStripeConnectVerified == connectAccountFlag.ENABLED || isStripeConnectVerified == connectAccountFlag.PENDING) {
      setRoomDetail({ ...roomDetail, room: { ...roomDetail.room, paid: true } });
    }
    if (prevStripeStatus != isStripeConnectVerified && isStripeRequesting) {
      if (isStripeConnectVerified == connectAccountFlag.APPROVED) {
        if (paidRef != undefined && !roomDetail.room.paid) {
          if (paidRef.current != undefined) {
            setTimeout(function () {
              paidRef.current.click();
            }, 100);
          }
        }

        setTimeout(function () {
          let {
            paid = false,
            groupName = "",
            password = "",
            publish = false,
            userName = "",
            id = "",
            category = "",
          } = userLoginData?.room || {};

          let updateDetail = {
            paid,
            groupName,
            password,
            publish,
            userName,
            id,
            category,
            room_amount: "",
            endDate: "",
          };

          if (paid) {
            if (userLoginData.room?.endDate) {
              updateDetail.endDate = new Date(userLoginData.room?.endDate);
            }

            if (userLoginData?.paidDetail?.amount) {
              updateDetail.room_amount = userLoginData?.paidDetail?.amount;
            }
          }

          setRoomDetail({
            room: {
              ...updateDetail,
              paid: true,
            },
          });

          setConnectAccount(true);
          setConnectAccountVerified(connectAccountFlag.APPROVED);
          setConnectApprovedFlash(true);
        }, 500);

        dispatch(setStripeRequesting(false));
        setTimeout(function () {
          setConnectApprovedFlash(false);
        }, ct("stripeMessage.successFlushTime", "stripeMessage"));
      } else {
        if (isStripeConnectVerified) {
          setConnectAccountVerified(isStripeConnectVerified);
        }
      }
    }
  }, [isStripeConnectVerified]);

  const handlePaidToggle = (
    showMessage = true,
    type = "",
    showModal = false
  ) => {
    if (showModal == true) {
      setShowAccountModal(true);
      return false;
    }

    let user_id = userLoginData?.user?.id;
    setConnectPop(true);

    if (connectAccountVerified == connectAccountFlag.PENDING) {
      return false;
    }

    if (showMessage && type == "update") {
      toast(
        ct("stripeMessage.paymentAccountNVerify", "stripeMessage"),
        Constant.App.ToastTime.LongCloseTime
      );
    } else if (showMessage) {
      toast(
        ct("rta-trmc.dashboard.myRoom.dontConnectAccount"),
        Constant.App.ToastTime.LongCloseTime
      );
    }

    let isEdit = 0;

    if (type == "update") {
      isEdit = 1;
    }

    let _this = this;
    setTimeout(
      function () {
        // if (connectPop) {
        dispatch(showApiLoader());

        let popUid = uuidv4();
        dispatch(setStripeRequesting(true));

        createConnectLink(user_id, popUid).then(async (resp) => {
          dispatch(hideApiLoader());
          if (resp.status == 1) {
            let redir = resp.data?.data?.link;
            if (redir) {
              // var win = window.open(config.socket_endpoint + "/api/v1/create-connect-account?session_id=" + popUid + "&uid=" + (user_id) + "&isEdit=" + (isEdit) + "", 'newwin', 'height=800px,width=600px');
              // var win = window.open(redir);
              var win = handlePaymentWindow(redir);
              if (props.stripeSession) {
                props.stripeSession({
                  uid: popUid,
                  win,
                });
              }
            } else {
              toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime);
            }
          } else {
            toast(await dynamicMessageLocale(resp?.message), Constant.App.ToastTime.LongCloseTime);
          }
        });
        // }
      },
      showMessage ? 5000 : 0
    );
  };

  if (isloading || isEmpty(roomDetail)) {
    return (
      <ModalDialog heading="Room Settings">
        <div className="spinner">{ct("rta-trmc.dialogs.loadingPleaseWait")}</div>
      </ModalDialog>
    );
  }

  const makeid = (length) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const changePrivateClaim = ({ target: { value, name } }) => {
    let password = roomDetail.room.password;
    if (!roomDetail.room.password || roomDetail.room.password == "") {
      password = makeid(5);
    }

    setRoomDetail({
      ...roomDetail,
      room: {
        ...roomDetail.room,
        password: password,
        private: !roomDetail.room.private,
      },
    });
  };

  const changeToggle = ({ target: { value, name } }) => {
    setRoomDetail({
      ...roomDetail,
      room: {
        ...roomDetail.room,
        [name]: !roomDetail.room[name],
      },
    });
  };

  const changeField = ({ target: { value, name } }) => {
    if (name == "room_amount") {
      if (value) {
        value = parseInt(value);
      }
    }
    setRoomDetail({
      ...roomDetail,
      room: {
        ...roomDetail.room,
        [name]: value,
      },
    });
  };

  const roomRequestFn = () => {
    if (roomDetail.room.publish) {
      if (roomDetail.room.category == "") {
        setErrors({
          ...errors,
          category: ct("stripeMessage.selectcategory", "stripeMessage"),
        });
        return;
      }
    }

    let amount = roomDetail.room.room_amount;

    if (roomDetail.room.paid) {
      if (!amount) {
        setErrors({
          ...errors,
          payment: ct("stripeMessage.roomAmount", "stripeMessage"),
        });
        return;
      } else if (amount < stripeMessage.roomAmountMin) {
        setErrors({
          ...errors,
          payment: ct("stripeMessage.roomAmountLess", "stripeMessage"),
        });
        return;
      } else if (amount > stripeMessage.roomAmountMax) {
        setErrors({
          ...errors,
          payment: ct("stripeMessage.roomAmountGreat", "stripeMessage"),
        });
        return;
      }
    }

    const isSubscriptionActive = checkSubscription();
    if (!isSubscriptionActive) {
      handleSubscription();
      return false;
    }

    let sendPay = {
      ...roomDetail.room,
      userName: userLoginData?.user?.username,
      email: userLoginData?.user?.email,
      organization_id: authOrganization._id,
    };

    if (sendPay.private == false) {
      sendPay.password = "";
    }
    if (sendPay.publish == false) {
      sendPay.category = "";
    }
    if (!sendPay.paid) {
      sendPay.room_amount = 0;
    }

    setSubmitLoading(true);

    let roomRequest = "";

    if (roomType == "create-room") {
      sendPay = Object.assign({
        autohost: clickedAutoMakeHost
      }, sendPay)
      roomRequest = claimRoomRequest(sendPay);
    } else {
      roomRequest = updateRoomDetail(sendPay);
    }
    roomRequest.then(async (response) => {
      setSubmitLoading(false);
      if (response.status) {
        let res = response.data;
        changePopupState("");
        Toast(
          roomType == "create-room"
            ? ct("messages.roomClaimSuccess", "messages")
            : ct("messages.roomUpdateSuccess", "messages"),
          Constant.App.ToastTime.LongCloseTime
        );
        let createdData = {
          ...userLoginData,
          isAdmin: true,
          isOpenRoom: !res.private,
          isAlreadyPaid: true,
          isLogged: true,
          isRoomClaimed: true,
          isPasswordProtected: res.private,
          isSecondaryModerator: false,
          isPrivate: res.isPrivate,
          room: {
            organization_id: res.organization_id,
            paid: res.paid,
            private: res.private,
            publish: res.publish,
            category: res.category,
            password: res.password,
            endDate: res?.endDate,
            groupName: res?.groupName,
          },
          paidDetail: {
            amount: res?.paidDetail?.amount || res?.paid_detail?.amount,
          },
        };

        console.log("set paid detail ", createdData);

        dispatch(setUserLoginData(createdData, 1));
        let userPosition = await getUserLocation()

        if (roomType == "create-room") {
          let obj = {
            userId: userLoginData?.user?.id,
            isAdmin: true,
            name: userLoginData.user.username,
            email: userLoginData.user.email,
            roomName: res?.groupName,
            socketId: localStorage.getItem("socketId"),
            organization_id: authOrganization?._id,
            organization: authOrganization?.name,
            ...userPosition.basicInfo
          };
          dispatch(toggleLobbyMode(true))
          socketEmit("user_added", obj);
        }
      } else {
        if (response?.message) {
          Toast(await dynamicMessageLocale(response.message), Constant.App.ToastTime.LongCloseTime);
        } else {
          Toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime);
        }
      }
    });
  };

  let prevDate = usePrevious(roomDetail.room.endDate);
  useEffect(
    function () {
      if (prevDate != roomDetail.room.endDate) {
        if (eDateRef) {
          if (eDateRef.current) {
            setTimeout(function () {
              eDateRef.current.setOpen(false);
            }, 100);
          }
        }
      }
    },
    [roomDetail.room.endDate]
  );

  let prevRoom = usePrevious(roomDetail.room);

  useEffect(() => {
    if (prevRoom) {
      if (prevRoom.category != roomDetail.room.category) {
        if (errors.category) {
          setErrors({
            ...errors,
            category: "",
          });
        }
      }

      if (prevRoom.room_amount != roomDetail.room.room_amount) {
        if (errors.payment) {
          setErrors({
            ...errors,
            payment: "",
          });
        }
      }

      if (prevRoom.endDate != roomDetail.room.endDate) {
        if (errors.roomDate) {
          setErrors({
            ...errors,
            roomDate: "",
          });
        }
      }
    }
  }, [roomDetail.room]);

  const handleLectureDate = (date) => {
    try {
      let val = date;
      if (date) {
        val = date.toLocaleDateString("en-US");

        let reg = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/;

        if (reg.test(val)) {
          let setDate = moment(val).format("YYYY-MM-DD");

          setRoomDetail({
            ...roomDetail,
            room: {
              ...roomDetail.room,
              endDate: new Date(setDate),
            },
          });
        }
      } else {
        setRoomDetail({
          ...roomDetail,
          room: {
            ...roomDetail.room,
            endDate: "",
          },
        });
      }
    } catch (e) {
      console.log("date error ", e);
    }
  };

  const closePaymentAccount = () => {
    setShowAccountModal(false);
  };

  const submitPaymentAccount = () => {
    setShowAccountModal(false);
    handlePaidToggle(false);
  };

  const renderAccountView = () => {
    // if (!connectAccount) {
    //   return <div className="disable-toggle s"
    //     onClick={() => handlePaidToggle(true, "update", true)}
    //   ></div>
    // } else {
    //   if (connectAccountVerified == "pending") {
    //     return <div className="disable-toggle w"></div>
    //   } else if (connectAccountVerified == "" || connectAccountVerified == "failed") {
    //     return <div className="disable-toggle w"
    //     // onClick={(e) => handlePaidToggle(true, "update")}
    //     ></div>
    //   }
    // }

    if (userLoginData?.user?.connectVerified == connectAccountFlag.ENABLED) {
      return null;
    }

    if (!connectAccount) {
      return (
        <Button
          appearance="primary"
          onClick={() => handlePaidToggle(false)}
          type="button"
          className="submit-button join-meeting-pass  mt-4 paid-lecture-btn"
        >
          {ct("stripeMessage.createConnectAccount", "stripeMessage")}
        </Button>
      );
    } else {
      if (userLoginData?.user?.connectVerified == connectAccountFlag.FAILED) {
        return (
          <Button
            appearance="primary"
            onClick={() => handlePaidToggle(false)}
            type="button"
            className="submit-button join-meeting-pass mt-4 paid-lecture-btn"
          >
            {ct("stripeMessage.updateConnectAccount", "stripeMessage")}
          </Button>
        );
      } else if (
        userLoginData?.user?.connectVerified == connectAccountFlag.ENABLED
      ) {
        return (
          <Button
            appearance="primary"
            onClick={() => handlePaidToggle(false)}
            type="button"
            className="submit-button join-meeting-pass mt-4 paid-lecture-btn"
          >
            {ct("stripeMessage.updateAdditionalConnectAccount", "stripeMessage")}
          </Button>
        );
      }
    }
    return null;
  };

  console.log("isLoading ", isSubmitLoading)
  return (
    <>
      {showAccountModal && (
        <PaymentAccountModal
          onClose={closePaymentAccount}
          onSubmit={submitPaymentAccount}
          defaultMessage={true}
        />
      )}
      <Dialog
        disableAutoHideOnSubmit={true}
        disableBackdropClose={true}
        hideCloseButton={true}
        onCancel={() => {
          changePopupState("");
          setConnectPop(false);
        }}
        onSubmit={roomRequestFn}
        cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
        ok={{ translationKey: roomType == "create-room" ? ct("rta-trmc.dialogs.create") : ct("rta-trmc.dialogs.update") }}
        titleKey={roomType == "create-room" ? ct("rta-trmc.dialogs.claimRoom") : ct("rta-trmc.dialogs.updateRoomSettings")}
        rtaClassName="claim-room-modal-wrapper"
        testId={"claim-room-modal"}
      // isLoading={isSubmitLoading}
      >
        {/* <ModalDialog
        heading={
          roomType == "create-room" ? "Claim Room" : "Update Room Settings"
        }
        components={{
          Footer: () => (
            <Footer
              text={roomType == "create-room" ? "Create" : "Update"}
              isHide={false}
              isLoading={isSubmitLoading}
              onSubmit={roomRequestFn}
              onClose={() => {
                changePopupState(""), setConnectPop(false);
              }}
              showKeyline={false}
            />
          ),
          Container: "div",
        }}
        testId={"claim-room-modal"}
      > */}
        <div className="mb-2">
          <label htmlFor="roomname" data-set={JSON.stringify(roomDetail)}>
            {ct("rta-trmc.dashboard.myRecording.roomName")}:{" "}
          </label>
          <input
            name="groupName"
            type="text"
            id="roomname"
            value={roomDetail.room.groupName}
            className="form-control"
            readOnly
          />
        </div>
        <div className="mb-2 public-private">
          <div className="public-private__left">
            <Toggle
              testId="private-toggle"
              size="large"
              id="private"
              value={roomDetail.room.private}
              name="private"
              onChange={changePrivateClaim}
              isChecked={roomDetail.room.private}
            />
            <label htmlFor="private">
              {ct("rta-trmc.dashboard.myRoom.private")}: {roomDetail.room.private ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}{" "}
            </label>
          </div>
          {roomDetail.room.private && (
            <div className="public-private__right mt-2 d-flex">
              <label>{ct("rta-trmc.dialogs.RoomPassword")}: {roomDetail.room.password}</label>
              <Tooltip title={ct("messages.tooltipCopyPassword", "messages")} arrow>
                <i onClick={() => {
                  copyText(roomDetail.room.password);
                  toast(
                    ct("messages.copyPassword", "messages"),
                    Constant.App.ToastTime.LongCloseTime
                  );
                }}
                  className="fa fa-clone theme-font-color ml-2" style={{ cursor: 'pointer' }} aria-hidden="true"></i>
              </Tooltip>
            </div>
          )}
        </div>

        <div className="publish-room mb-2" data-se={JSON.stringify(roomDetail)}>
          <div className="publish-switch">
            <Toggle
              testId="public-toggle"
              size="large"
              id="publish"
              value={roomDetail.room.publish}
              name="publish"
              onChange={changeToggle}
              isChecked={roomDetail.room.publish}
            />
            <label htmlFor="publish">
              {ct("rta-trmc.dialogs.published")}: {roomDetail.room.publish ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}{" "}
            </label>
          </div>
          {roomDetail.room.publish && (
            <>
              <div className="publish-cat mt-2">
                <label htmlFor="category">{ct("rta-trmc.dashboard.myRoom.category")}:</label>
                <select
                  id="category"
                  value={roomDetail.room.category}
                  name="category"
                  onChange={changeField}
                  className="form-control roomCategory mb-1"
                >
                  <option value="">{ct("rta-trmc.dashboard.myRoom.selectCategory")}</option>
                  <option value="Uncategorized">{ct("rta-trmc.dialogs.uncategorized")}</option>
                  <option value="Music">{ct("rta-trmc.dialogs.music")}</option>
                  <option value="Vocal">{ct("rta-trmc.dialogs.vocal")}</option>
                  <option value="Training">{ct("rta-trmc.dialogs.training")}</option>
                  <option value="Singing">{ct("rta-trmc.dialogs.singing")}</option>
                </select>
                {errors.category && (
                  <label className={classes.inputError}>
                    {errors.category}
                  </label>
                )}
              </div>
            </>
          )}
        </div>
        {getBaseConfig("paidLecture") == true && (
          <>
            <div className="paid-room">
              <div
                className={
                  "paid-switch " + (roomDetail.room.paid ? "mb-4" : "")
                }
              >
                <Toggle
                  testId="paid-toggle"
                  size="large"
                  id="paid"
                  name="paid"
                  // onChange={changeToggle}
                  onChange={(e) => changeToggle(e)}
                  isChecked={roomDetail.room.paid}
                  ref={paidRef}
                />
                <label htmlFor="paid">
                  {ct("rta-trmc.dashboard.myRoom.paid")}:{roomDetail.room.paid ? ct("Translate.buttonTitle.yesSmall") : ct("Translate.buttonTitle.noSmall")}
                </label>
              </div>

              {connectAccount && connectApprovedFlash && (
                <div className="payment-status-container-suc">
                  {ct("stripeMessage.paymentAccountApproved", "stripeMessage")}
                </div>
              )}

              {roomDetail.room.paid && (
                <>
                  <div className="paid-fields mb-4">
                    <label>{ct("rta-trmc.dashboard.myRoom.entranceFee")}:</label>
                    <input
                      name="room_amount"
                      type="text"
                      value={roomDetail?.room?.room_amount}
                      placeholder="$"
                      className="input-control form-control mb-1"
                      onChange={(e) => {
                        let val = e.target.value;
                        const re = /^[0-9\b]+$/;
                        if (e.target.value === "" || re.test(val)) {
                          if (/^0/.test(val)) {
                            val = val.replace(/^0/, "");
                          }

                          setRoomDetail({
                            ...roomDetail,
                            room: {
                              ...roomDetail.room,
                              room_amount: val,
                            },
                          });
                        }
                      }}
                    />
                    {errors.payment && (
                      <label className={classes.inputError}>
                        {errors.payment}
                      </label>
                    )}
                  </div>
                  <div className="room-end-date-container">
                    <label htmlFor="room-end-date">{ct("rta-trmc.dialogs.roomAccessEndDate")}:</label>
                    <label className="w-100">
                      <DatePicker
                        dateFormat="MM-dd-yyyy"
                        selected={roomDetail.room?.endDate}
                        value={roomDetail.room?.endDate}
                        onChange={handleLectureDate}
                        placeholderText="MM-DD-YYYY"
                        minDate={new Date()}
                        ref={eDateRef}
                        shouldCloseOnSelect={true}
                        locale={localeCalender()}
                      />
                      {errors.roomDate && (
                        <label className={classes.inputError}>
                          {errors.roomDate}
                        </label>
                      )}
                    </label>
                  </div>
                  <>{renderAccountView()}</>
                  {connectAccount &&
                    (connectAccountVerified == connectAccountFlag.FAILED ||
                      connectAccountVerified == connectAccountFlag.PENDING) && (
                      <span style={{ color: "black" }}>
                        {connectAccountVerified == connectAccountFlag.FAILED ? (
                          <div className="payment-status-container-fld">
                            <div>
                              <i className="fa fa-times"></i>
                            </div>
                            <div style={{ marginLeft: 10 }}>
                              <b>{ct("rta-trmc.dashboard.myRoom.error")}: </b>
                              {ct("stripeMessage.paymentAccountFailed", "stripeMessage")}
                              <span
                                style={{
                                  color: "var(--theme-primary-color)",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handlePaidToggle(false, "update")
                                }
                              > {ct("rta-trmc.dashboard.myRoom.clickHere")}</span> {ct("rta-trmc.dashboard.myRoom.toUpdateAcc")}
                            </div>
                          </div>
                        ) : (
                          <div className="payment-status-container-prg">
                            {ct("stripeMessage.paymentAccountVerification", "stripeMessage")}
                          </div>
                        )}
                      </span>
                    )}
                </>
              )}
            </div>
          </>
        )}
        {/* </ModalDialog> */}
      </Dialog>
    </>
  );
};

export default ClaimRoomModel;
